import type React from "react";

/**
 * Style DS partagé des étapes du parcours Pennylane (#1136) — carte teintée
 * (`TINTED_CARD_STYLE`) et marqueur circulaire (`MilestoneMarker`), consommés
 * par `PennylaneRecapModal.tsx` et `EinvoicingPennylaneTunnelState.tsx`.
 * Wash violet DS (`--mt-color-action-rgb`), jamais ambre — mock-up validé #1098.
 */

// Même formule rgba que les cartes d'état existantes (`RESOLVED_CARD_TINT`,
// `packages-web/ui/.../statusCardStyles.ts`).
export const TINTED_CARD_STYLE: React.CSSProperties = {
  borderRadius: 10,
  padding: "12px 14px",
  background: "rgba(var(--mt-color-action-rgb), 0.05)",
  border: "1px solid rgba(var(--mt-color-action-rgb), 0.25)",
};

export function MilestoneMarker({
  done,
  fail,
  children,
}: {
  done: boolean;
  fail?: boolean;
  children: React.ReactNode;
}) {
  // Pastille d'échec : même formule rgba que les pastilles de statut existantes
  // (`RESOLVED_ICON_TINT`, `packages-web/ui/.../statusCardStyles.ts`).
  const style: React.CSSProperties = {width: 28, height: 28, fontSize: "0.82rem", fontWeight: 700};
  if (fail) {
    style.background = "rgba(var(--mt-color-action-rgb), 0.14)";
    style.color = "var(--mt-color-action)";
  }
  return (
    <div
      className={`d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle ${
        fail ? "" : done ? "bg-primary text-white" : "border border-2 text-muted"
      }`}
      style={style}
    >
      {children}
    </div>
  );
}
